import { DesignUploadMode } from 'swag-common/interfaces';
export default function isFullDesign(product) {
  return product && product.designUploadMode === DesignUploadMode.fullDesign;
}